/**
 * Pedir un enlace de recuperación — `OD-0027 D-04`.
 *
 * `202` IDÉNTICO exista o no la cuenta, y el mismo texto en pantalla: esta
 * página no sirve para averiguar qué emails tienen cuenta.
 */
import { useState } from "react";
import { api, ESTADO_VALIDACION } from "../api/cliente";
import { t } from "../i18n/es";
import { Aviso, Boton, Campo, Tarjeta } from "../ui/primitivas";

export function PantallaRecuperar({ hayConexion, onVolver }: { hayConexion: boolean; onVolver: () => void }) {
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState<string | null>(null);
  const [errorGeneral, setErrorGeneral] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  async function enviar(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setErrorGeneral(null);
    if (email.trim() === "") {
      setErrorEmail(t.recuperar.faltaEmail);
      return;
    }
    setErrorEmail(null);

    setEnviando(true);
    const r = await api.pedirRecuperacion(email.trim());
    setEnviando(false);

    if (r.ok) {
      setEnviado(true);
      return;
    }
    if (r.estado === 0) setErrorGeneral(t.comun.sinRed);
    else if (r.estado === 429) setErrorGeneral(t.comun.demasiadosIntentos);
    else if (r.estado === ESTADO_VALIDACION) setErrorEmail(t.registro.emailNoValido);
    else setErrorGeneral(t.comun.errorGenerico);
  }

  if (enviado) {
    return (
      <Tarjeta titulo={t.recuperar.titulo}>
        <Aviso tono="exito" titulo={t.recuperar.enviadoTitulo}>
          {t.recuperar.enviadoDetalle}
        </Aviso>
        <Boton variante="secundario" onClick={onVolver}>
          {t.recuperar.volver}
        </Boton>
      </Tarjeta>
    );
  }

  return (
    <Tarjeta titulo={t.recuperar.titulo}>
      <p>{t.recuperar.detalle}</p>
      <form onSubmit={enviar} noValidate>
        <Campo
          id="recuperar-email"
          etiqueta={t.login.email}
          valor={email}
          onChange={setEmail}
          tipo="email"
          inputMode="email"
          autoComplete="email"
          error={errorEmail}
          autoFocus
        />
        {errorGeneral !== null ? <Aviso tono="error">{errorGeneral}</Aviso> : null}
        {!hayConexion ? <Aviso tono="aviso">{t.comun.sinRed}</Aviso> : null}
        <Boton tipo="submit" deshabilitado={enviando || !hayConexion}>
          {enviando ? t.recuperar.enviando : t.recuperar.enviar}
        </Boton>
      </form>
      <Boton variante="secundario" onClick={onVolver}>
        {t.recuperar.volver}
      </Boton>
    </Tarjeta>
  );
}
